import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

export default new Vuex.Store({
  state: {
    site: [],
    home: [],
    homeloading: true,
    about: [],
    artistlist: [],
    artists: [],
    artistloading: true,
    project: [],
    test: [],
    production: [],
    introScroll: false
  },
  getters: {
    getArtistByUID: state => (uid, collection = state.artists) => {
      let i = collection.length;
      while (i--) {
        if (collection[i].uid === uid) {
          return collection[i];
        }
      }
    }
  },
  actions: {
    async loadSite({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "site",
            select: {
              title: true,
              instagram: true,
              vimeo: true,
            }
          },
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD
            }
          }
        )
        .then(function(response) {
          commit("SET_SITE", response.data.result);
        });
    },
    async loadHome({ commit }) {
      commit("SET_HOMELOADING", true);
      await axios
        .post(
          "/api/home",
          {
          //   query: "page('home').layout.toStructure",
          //   select: {
          //     type: "structureItem.type",
          //     // artist: "structureItem.pagelink.toPage.parent.title",
          //     // artistuid: "structureItem.pagelink.toPage.parent.uid",
          //     title: "structureItem.pagelink.toPage.title.value",
          //     // occupation: "structureItem.pagelink.toPage.parent.occupation",
          //     uid: "structureItem.pagelink.toPage.uid",
          //     quantity: "structureItem.quantity",
          //     parent: {
          //       query: "structureItem.pagelink.toPage.parent",
          //       select: {
          //         title: "page.title.value"
          //       }
          //     },
          //     images: {
          //       query: "structureItem.pagelink.toPage.images.sortBy('sort')",
          //       select: {
          //         url: "file.resize(1000).url",
          //         thumb: "file.resize(100).url"
          //       }
          //     },
          //     videos: {
          //       query: "structureItem.pagelink.toPage.videos.sortBy('order')",
          //       select: {
          //         url: "file.url"
          //       }
          //     }
          //   }
          },
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD
            }
          }
        )
        .then(function(response) {
          // console.log(response);
          commit("SET_HOME", response.data);
        })
        .finally(() => {
          commit("SET_HOMELOADING", false);
        });
    },
    async loadProduction({ commit }) {
      await axios
        .post(
          "/api/production",
          {},
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD
            }
          }
        )
        .then(function(response) {
          // console.log(response);
          commit("SET_PRODUCTION", response.data);
        })
        .finally(() => {
      //     commit("SET_HOMELOADING", false);
        });
    },
    async loadAbout({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('about')",
            select: {
              title: true,
              uid: true,
              text: "page.text_md.kirbytext",
              address: "page.address_md.kirbytext",
              director: "page.director_md.kirbytext",
              producer: "page.producer_md.kirbytext"
            }
          },
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD
            }
          }
        )
        .then(function(response) {
          commit("SET_ABOUT", response.data.result);
        });
    },
    async loadArtists({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('artists').children.listed",
            select: {
              title: true,
              uid: true,
              occupation: true,
              poster:
                "page.children.first.images.sortBy('sort').first.resize(1400).url"
            }
          },
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD
            }
          }
        )
        .then(function(response) {
          commit("SET_ARTISTS", response.data.result.data);
        });
    },
    async loadProject({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query:
              "page('artists').children.find('" +
              payload.artist +
              "').children.find('" +
              payload.project +
              "')",
            select: {
              title: true,
              uid: true,
              artist: "page.parent.title",
              artistuid: "page.parent.uid",
              projecttype: "page.projecttype",
              category: "page.category.split",
              images: {
                query: "page.images.sortBy('sort')",
                select: {
                  url: "file.resize(1400).url",
                  width: "file.width",
                  height: "file.height",
                  srcset: "file.srcset([600, 1100, 1400, 2000, 2400])",
                  extension: "file.extension",
                  thumb: "file.resize(400).url"
                }
              },
              videos: {
                query: "page.videos",
                select: {
                  url: true,
                  extension: "file.extension",
                  cover: "file.resize(250).url"
                }
              }
            }
          },
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD
            }
          }
        )
        .then(function(response) {
          commit("SET_PROJECT", response.data.result);
        });
    },
    async loadAllProjects({ commit, dispatch }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('artists').children.find('" + payload.uid + "')",
            select: {
              projects: {
                query: "page.children.listed",
                select: {
                  title: true,
                  uid: true,
                  category: "page.category.split",
                  images: {
                    query: "page.images.sortBy('sort')",
                    select: {
                      url: "file.resize(1000).url",
                      extension: "file.extension",
                      thumb: "file.resize(500).url"
                    }
                  }
                },
                pagination: {
                  page: payload.num,
                  limit: 20
                }
              }
            }
          },
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD
            }
          }
        )
        .then(function(response) {
          if (
            response.data.result.projects.pagination.page <
            response.data.result.projects.pagination.pages
          ) {
            dispatch("loadAllProjects", {
              uid: payload.uid,
              num: payload.num + 1
            });
          }
          commit("SET_ALLPROJECTS", {
            artist: payload.uid,
            projects: response.data.result.projects
          });
        });
    },
    async loadArtist({ commit, dispatch }, payload) {
      commit("SET_ARTISTLOADING", true);
      await axios
        .post(
          "/api/query",
          {
            query: "page('artists').children.find('" + payload.uid + "')",
            select: {
              title: true,
              uid: true,
              filters: "page.filters.split",
              website: true,
              biography: "page.biography_md.kirbytext",
              occupation: true,
              poster: "page.children.first.images.sortBy('sort').first.url",
              projects: {
                query: "page.children.listed",
                select: {
                  title: true,
                  uid: true,
                  category: "page.category.split",
                  images: {
                    query: "page.images.sortBy('sort')",
                    select: {
                      url: "file.resize(1000).url",
                      // srcset: "file.srcset([600, 1100, 1400])",
                      extension: "file.extension",
                      thumb: "file.resize(500).url"
                    }
                  }
                },
                pagination: {
                  limit: 20
                }
              }
            }
          },
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD
            }
          }
        )
        .then(function(response) {
          if (response.data.result.projects.pagination.total > 20) {
            dispatch("loadAllProjects", {
              uid: payload.uid,
              num: 2
            });
          }
          commit("SET_ARTIST", response.data.result);
        })
        .finally(() => {
          commit("SET_ARTISTLOADING", false);
        });
    }
  },
  mutations: {
    SET_SITE(state, site) {
      state.site = site;
    },
    SET_HOME(state, home) {
      state.home = home;
    },
    SET_HOMELOADING(state, payload) {
      state.homeloading = payload;
    },
    SET_PRODUCTION(state, data) {
      state.production = data;
    },
    SET_ABOUT(state, about) {
      state.about = about;
    },
    SET_ARTISTS(state, artists) {
      // console.log('set artists', artists);
      state.artistlist = artists;
    },
    SET_ARTIST(state, artist) {
      state.artists.push(artist);
    },
    SET_ALLPROJECTS(state, payload) {
      // console.log(
      //   payload.projects.pagination.page,
      //   payload.projects.pagination.pages
      // );
      state.artists.find(element => {
        if (element.uid === payload.artist) {
          for (var i = 0; i < payload.projects.data.length; i++) {
            element.projects.data.push(payload.projects.data[i]);
          }
          // let newArray = element.projects.concat(payload.projects);
          // element.projects = newArray;
        }
      });
    },
    SET_PROJECT(state, project) {
      state.project = project;
    },
    SET_ARTISTLOADING(state, payload) {
      state.artistloading = payload;
    }
  }
});
